// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8d2da060","488":"e95a4796"}[chunkId] + ".chunk.js";
};